import { initSimpleConsentManager, openSimpleConsentManager, requestConsentSimpleConsentManager } from './simpleConsentManager';

// List of services available for consent
export const consentManagerServices = {
    matomo: 'Matomo',
    youtube: 'Youtube'
};

initSimpleConsentManager();

export function openConsentManager () {
    openSimpleConsentManager();
}

export function requestConsent (service: string) {
    requestConsentSimpleConsentManager(service);
}